/**
 * Nass Flip Cards — tap/keyboard toggle for the 3D flip cards
 * (Body Transformation "Not lazy" block). Desktop hover flip is pure
 * CSS; this only handles the explicit toggle (mobile tap + Enter/Space),
 * same as the handoff's `flipToggle` handler.
 */
function toggle(card) {
  const flipped = card.dataset.flipped === '1';
  card.dataset.flipped = flipped ? '0' : '1';
  card.setAttribute('aria-pressed', flipped ? 'false' : 'true');
}

document.addEventListener('click', (e) => {
  const card = e.target.closest('[data-nass-flip]');
  if (card) toggle(card);
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const card = e.target.closest('[data-nass-flip]');
  if (card) {
    e.preventDefault();
    toggle(card);
  }
});
